<template>
    <!-- 题库管理 -->
    <div class="campus-list">
        <div class="conditionSearchBox" v-if="!isSelect">
            <div class="conditionItem">
                <el-input v-model="params.condition.subject" placeholder="题库名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <div>
            <el-button type="primary" icon="el-icon-plus" v-if="!isSelect" @click="openQuestionDialog('')">新增题库</el-button>
            <el-button type="primary" plain icon="el-icon-delete" @click="isSelect = true" v-if="!isSelect">批量删除</el-button>
            <el-button type="primary" v-if="isSelect" @click="deleteQuestion('')" :disabled="selection.length === 0">批量删除 ({{selection.length}})</el-button>
            <el-button type="primary" plain v-if="isSelect" @click="cancelDelete">取消批量删除</el-button>
        </div>
        <div class="mt-15">
            <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" @selection-change="handleSelectionChange" ref="table" :row-key="getRowKey">
                <el-table-column type="selection" v-if="isSelect" fixed key="selection" class-name="selection" align="right" :width="getTableHeaderWidthByCheckCol(isSelect)"></el-table-column>
                <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                    <template slot-scope="scope">
                        <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                    </template>
                </el-table-column>
                <el-table-column prop="subject" label="题库名称" fixed align="center" min-width="300" key="subject" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="flex al-c">
                            <img class="img" :src="scope.row.coverurl ? scope.row.coverurl : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" alt="">
                            <p style="line-height:40px;" class="text-ellipse">{{scope.row.subject}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="ordersucccount" label="使用量" align="center" width="100" key="ordersucccount" :formatter="formatTab" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="statusname" label="状态" align="center" width="100" key="statusname" :formatter="formatTab">
                    <template slot-scope="scope">
                        <p v-if="scope.row.status === 0" style="color: #E6A23C;">草稿</p>
                        <p v-if="scope.row.status === 30" style="color: #67C23A;">已发布</p>
                        <p v-if="scope.row.status === 100" style="color: #F56C6C;">已删除</p>
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="创建时间" align="center" width="150" key="datetime" show-overflow-tooltip :formatter="formatTab"></el-table-column>
                <el-table-column prop="" label="操作" fixed="right" align="right" :width="getTableHeaderWidthByOpButton3()" key="edit" v-if="!isSelect">
                    <template slot-scope="scope">
                        <div class="color-brand flex jc-sa ai-c">
                            <p class="pointer" @click="openQuestionDialog(scope.row.code)">编辑</p>
                            <p class="pointer" v-if="scope.row.status === 0" @click="sendQuestion(scope.row)">发布</p>
                            <p v-else class="color-text-sec">发布</p>
                            <p class="pointer" v-if="scope.row.status === 0 || scope.row.status === 30" @click="deleteQuestion(scope.row)">删除</p>
                            <p v-else class="color-text-sec">删除</p>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
        </div>
        <QuestionDialog ref="QuestionDialog" @saveSuccess="saveSuccess"></QuestionDialog>
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import {
  getQuestionbankList,
  updateQuestionbankStatus
} from '@/api/measApi/questionManage.js'
import QuestionDialog from './components/questionDialog.vue'
export default {
  data() {
    return {
      params: {
        condition: {
          subject: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      isSelect: false,
      tableData: [],
      total: 0,
      selection: [],
      contentLoading: false
    }
  },
  components: {
    TableSort,
    Page,
    QuestionDialog
  },
  created() {
    this.getQuestionbankList()
  },
  methods: {
    //   获取表格数据
    getQuestionbankList() {
      this.contentLoading = true
      getQuestionbankList(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.total = res.pageinfo.rowcount
          this.contentLoading = false
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getQuestionbankList()
    },
    // 重置
    reset() {
      this.params = {
        condition: {
          subject: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getQuestionbankList()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getQuestionbankList()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getQuestionbankList()
    },
    // 多选
    getRowKey(row) {
      return row.code
    },
    getdisabled(row) {
      return row.isedit
    },
    // 初始化表格
    formatTab(row, column, value) {
      return value ? value : '--'
    },
    // 选择
    handleSelectionChange(selection) {
      this.selection = selection
    },
    // 取消批量删除
    cancelDelete() {
      this.isSelect = false
      this.$refs.table.clearSelection()
      this.selection = []
    },
    // 打开新增编辑
    openQuestionDialog(code) {
      this.$refs.QuestionDialog.handleOpen(code)
    },
    // 保存成功
    saveSuccess() {
      this.params.page = 1
      this.getQuestionbankList()
    },
    // 发布
    sendQuestion(row) {
      this.$confirm('确定发布该题库吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'measElMessage'
      })
        .then(() => {
          updateQuestionbankStatus({ code: row.code, status: 30 }).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.params.page = 1
              this.getQuestionbankList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 删除
    deleteQuestion(row) {
      this.$confirm(
        '题库删除后将不在前台展示，但不影响已设置的题库信息，继续吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'measElMessage'
        }
      )
        .then(() => {
          let code = ''
          if (row) {
            code = row.code
          } else {
            let selectionCode = []
            this.selection.map(item => {
              selectionCode.push(item.code)
            })
            code = selectionCode.join(',')
          }
          updateQuestionbankStatus({ code: code, status: 100 }).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.params.page = 1
              this.getQuestionbankList()
              this.isSelect = false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table__empty-block {
  background: none;
}
.img {
  width: 40px;
  height: 40px;
  margin-left: 20px;
  margin-right: 10px;
}
</style>

